/*
Persistence: data remains until the tab is closed
*/
export default {
    methods: {
        async request(url) {
            console.log(`request: `+url);
            console.log(window.urls);
            if (window.urls===undefined) {
                window.urls=[];
            }
            if (!window.urls.includes(url)) {
                const successfully = await this.cacheStore(url);
                if (successfully===true) {
                    window.urls.push(url);
                }
            }
            return await this.cacheGet(url);
        },
        async cacheStore(url) {
            console.log('cacheStore');
            try {
                // open cache
                const cache = await caches.open('offline');
                // fetch and store response
                // await cache.add(url);
                await this.publicApiGet(`${window.location.origin.replace(':8082','')}/${url}`).then((response) => {
                    console.log('publicApiGet');
                    return cache.put(url, response);
                });
                return true;
            } catch (err) {
                return undefined; // store failed
            }
        },
        async cacheGet(url) {
            console.log('cacheGet');
            try {
                const
                    // open cache
                    cache = await caches.open('offline'),
                    // fetch stored response
                    resp = await cache.match(url);
                // return body text
                return await resp;
            } catch (err) {
                return undefined; // cache get failed
            }

        }
    },
}